import { EventsDTO } from '../models/events.modal';

export function hasCompleteWebinarRoomDetails(
  event: EventsDTO | null | undefined
): boolean {
  return [
    event?.roomId,
    event?.webinarId,
    event?.streamId,
    event?.webinarPasscode,
  ].every((value) => typeof value === 'string' && value.trim().length > 0);
}

/**
 * The authenticated host projection intentionally omits the provider passcode.
 * Starting the host chat room needs the provider identifiers, while the API
 * remains the authority that rejects an event whose stored provider state is
 * not ready. Do not use this check to issue an attendee Watch handoff.
 */
export function hasCompleteHostWebinarRoomDetails(
  event: EventsDTO | null | undefined
): boolean {
  return [event?.roomId, event?.webinarId, event?.streamId].every(
    (value) => typeof value === 'string' && value.trim().length > 0
  );
}

export function getWebinarStatusError(
  error: any,
  fallback = 'Unable to update the webinar status. Please try again.'
): string {
  const message = error?.message || error?.error?.message;
  return typeof message === 'string' && message.trim().length > 0
    ? message
    : fallback;
}

/** Host-only errors from Start and event management. */
export function getHostWebinarStatusError(error: any): string {
  const message =
    error?.error?.errorCode ||
    error?.error?.message ||
    error?.errorCode ||
    error?.message;
  if (message === 'EVENT_TIMEZONE_INVALID') {
    return 'This event has an invalid timezone. Edit the event schedule and choose a timezone before trying again.';
  }
  if (message === 'EVENT_SCHEDULE_INVALID') {
    return 'This event is missing a valid start or end time. Edit the schedule before trying again.';
  }
  if (message === 'EVENT_UNAVAILABLE') {
    return 'Publish this event before trying to start it.';
  }
  if (message === 'EVENT_ENDED') {
    return 'This event has ended and cannot be restarted. Create a new event if you need to host another session.';
  }
  if (message === 'EVENT_PROVIDER_NOT_READY') {
    return 'The webinar is not ready for attendees. Please try Start again. If it keeps failing, edit and re-publish the event.';
  }
  return getWebinarStatusError(error);
}
